(() => {
  document.addEventListener('click', event => {
    document.querySelectorAll('.cd-tag-group[open]').forEach(group => {
      if (!group.contains(event.target)) group.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cd-tag-group[open]').forEach(group => {
      if (group.contains(document.activeElement)) group.querySelector('summary').focus();
      group.removeAttribute('open');
    });
  });
})();